<template>
	<h1>UserInfo</h1>
</template>
<script>
	export default {
		data() {
			return {}
		}
	}
</script>